import { faCheck } from '@fortawesome/pro-solid-svg-icons';

import { useTranslate } from '@growtherapy/i18n';
import { Heading, Icon, Text, cn } from '@growtherapy/sprout-ui';

import { useTheme } from '../../hooks/useTheme';
import { Theme } from '../../state/theme';

export type AppointmentStatus = 'waiting' | 'in-session';

export function YoureAllSetForYourAppointmentCard({ status }: { status: AppointmentStatus }) {
  const t = useTranslate();
  const { theme } = useTheme();
  const isDarkTheme = theme === Theme.DARK;

  const subtext: Record<AppointmentStatus, string> = {
    waiting: t('telehealth-core:waitingRoom.youCanJoinWhenYourProviderIsReady'),
    'in-session': t('telehealth-core:waitingRoom.greatJobCheckingIn'),
  };

  return (
    <div className='flex h-full w-full flex-col items-center justify-center gap-4 p-8 text-center'>
      <Icon icon={faCheck} size='2xl' className={cn({ 'rebrand:text-text-inverse': isDarkTheme })} aria-hidden />
      <div className='flex flex-col gap-2 items-center'>
        <Heading as='h2' variant='md' className={cn({ 'rebrand:text-text-inverse': isDarkTheme })}>
          {t('telehealth-core:waitingRoom.youreAllSetForYourAppointment')}
        </Heading>
        <Text variant='md' className={cn({ 'rebrand:text-text-inverse': isDarkTheme })}>
          {subtext[status]}
        </Text>
      </div>
    </div>
  );
}
